import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { LeftArrow } from '../../../Assets/svgIcons';
import { queryByTestId } from '@testing-library/react';
import { formatCommaNumbers } from '../../../Utils/common.utils';

const transformData = (data) => {
  const groupedData = {};

  data.forEach(item => {
    if (!groupedData[item.name]) {
      groupedData[item.name] = [];
    }

    item.data.forEach(dateEntry => {
      dateEntry.data.forEach(actionData => {
        groupedData[item.name].push({
          date: dateEntry.date,
          action: actionData.action,
          total_quantity: actionData.total_quantity,
          total_price: actionData.total_price,
          average_price: actionData.average_price
        });
      });
    });
  });

  return groupedData;
};
const ProfitReportSymbol = ({ symbolReportByDay }) => {


  const symbolReportData = transformData(symbolReportByDay)
  return (
    <>
      {Object.keys(symbolReportData)?.map((symbol, index) => {
        return (
          <section className="page_design">
            <Container>
              {/* <div className="backbtn mb-3">
            <Link to="/account"><span><LeftArrow /></span> Back</Link>
          </div> */}
              <div className="page_design_in">
                <div className="page_design_head mb-3">
                  <h2>Profit & Loss  Report (<span className='grey_text'>Symbol Name:</span> {symbol})</h2>
                </div>
                <Row className="profitLoss_head">
                  {symbolReportData[symbol].map((item, index) => <Col xs={12} sm={6} className="profitLoss_head_col" key={index}>
                    <div className="profitLoss_head_item">
                      <ul className='profitLoss_head_ul'>
                        <li>{item.date}</li>
                        <li>

                          <span className={`${item.action === "ADD" ? "green_text" : "red_text"}`}>{item.action === "ADD" ? "Buy" : "Sell"}</span>
                        </li>
                      </ul>
                      <ul className='profitLoss_head_ulList'>
                        {/* {item.datalist.map((item, index) => { */}
                        {/* return ( */}
                        <li >Qty. Traded</li>
                        <li >{formatCommaNumbers(item.total_quantity)}</li>
                        <li >{item.action === "ADD" ? "Buy Avr." : "Sell Avr."}</li>
                        <li >{formatCommaNumbers(item.average_price)}</li><li >{item.action === "ADD" ? "Buy Amount" : "Sell Amount"}</li>
                        <li >{formatCommaNumbers(item.total_price)}</li>
                        {/* ); */}
                        {/* })} */}
                      </ul>
                    </div>
                  </Col>)}
                </Row>
              </div>
            </Container>
          </section>
        );
      })}
    </>
  )
}

export default ProfitReportSymbol
